<template>
    <ListadoControlDeAccesos
        :fields="fields" 
        :controlAcessos="controlAcessosEntradasOtros" 
        :filtros="filtros" 
        @getcontrolAcessos="getControlAcessosEntradasOtros" 
        :loading="loading"
    />
</template>

<script>
    import ListadoControlDeAccesos from "@/components/backend/eventos/sesiones/informe/ListadoControlDeAccesos.vue";
    export default {
        data() {
            return {
                evento_id :this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                fields: [
                    { key: "zona", label: "Zona"},
                    { key: "fila", label: "Fila"},
                    { key: "asiento", label: "Asiento"},
                    { key: "fecha", label: "Fecha / Hora de acceso"},
                    { key: "ticketera", label: "Ticketera"},
                    { key: "nombre", label: "Nombre"},
                    { key: "dni", label: "dni"},
                    { key: "qr_code", label: "Qr code"},
                    { key: "verifica", label: "Validada"}
                ],
                filtros: {
                    per_page: 10,
                    page: 1,
                    search: "",
                    status: "",
                    currentPage: 1,
                    rows: 0,
                    numPage: 10
                },
                controlAcessosEntradasOtros: {
                    data: [],
                    meta: {
                        current_page: 1,
                        from: 1,
                        last_page: 1,
                        path: "",
                        per_page: 10,
                        to: 1,
                        total: 1,
                    },
                },
                loading: false,
            }
        },
        methods: {
            getControlAcessosEntradasOtros() {
                this.loading = true;
                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        evento_id: this.evento_id,
                        status: this.filtros.status,
                        search : this.filtros.search,
                        page : this.filtros.page,
                        per_page : this.filtros.numPage,
                    },
                    sesion_id: this.sesion_id,
                    evento_id: this.evento_id,
                }
                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.informe.control-accesos.entradas-otros'), params).then(res => {
                    this.filtros.rows = res.data.meta.last_page;
                    this.filtros.perPage = res.data.meta.per_page > 5 ? res.data.per_page : 1;
                    this.filtros.currentPage = res.data.meta.current_page;
                    this.controlAcessosAbonos = res.data
                    this.controlAcessosEntradasOtros = res.data
                }).finally(() => (this.loading = false))
            },
        },
        components: {
            ListadoControlDeAccesos
        }
    }
</script>